export default {
    name: '',
    autoPopulate: '',
    newForm: 'new',
    uploadBudget: 'upload',
    byUnit: 'no',
    companyId: null,
    sections: [
        {
            name: 'Property Cost',
            additionalItems: [
                {
                    name: 'Aquistion Price (must tie to purchase contract)',
                    budgetAmount: '',
                    custom: 'no',
                },
                {
                    name: 'Initial Inspection',
                    budgetAmount: '',
                    custom: 'no',
                },
            ],
        },
        {
            name: 'Site Work',
            additionalItems: [
                {
                    name: 'Demolition',
                    budgetAmount: '',
                    custom: 'no',
                },
                {
                    name: 'Building Permit Fees',
                    budgetAmount: '',
                    custom: 'no',
                },
                {
                    name: 'Architecture, Engineering',
                    budgetAmount: '',
                    custom: 'no',
                },
            ],
        },
        {
            name: 'Exterior Structure',
            additionalItems: [
                {
                    name: 'Painting/Siding/Wall Finish',
                    budgetAmount: '',
                    custom: 'no',
                },
                {
                    name: 'Guters/Fascia, Downspout',
                    budgetAmount: '',
                    custom: 'no',
                },
                {
                    name: 'Porch/Deck',
                    budgetAmount: '',
                    custom: 'no',
                },
                {
                    name: 'Roofing',
                    budgetAmount: '',
                    custom: 'no',
                },
                {
                    name: 'Windows + Doors',
                    budgetAmount: '',
                    custom: 'no',
                },
                {
                    name: 'Garage Door',
                    budgetAmount: '',
                    custom: 'no',
                },
            ],
        },
        {
            name: 'Major Systems',
            additionalItems: [
                {
                    name: 'Plumbing (except fixtures)',
                    budgetAmount: '',
                    custom: 'no',
                },
                {
                    name: 'Electrical (except fixtures)',
                    budgetAmount: '',
                    custom: 'no',
                },
                {
                    name: 'HVAC',
                    budgetAmount: '',
                    custom: 'no',
                },
                {
                    name: 'Sewer/Septic',
                    budgetAmount: '',
                    custom: 'no',
                },
            ],
        },
        {
            name: 'Interior',
            additionalItems: [
                {
                    name: 'Insulation',
                    budgetAmount: '',
                    custom: 'no',
                },
                {
                    name: 'Drywall',
                    budgetAmount: '',
                    custom: 'no',
                },
                {
                    name: 'Interior Trims, Doors, and Mirrors',
                    budgetAmount: '',
                    custom: 'no',
                },
                {
                    name: 'Painting',
                    budgetAmount: '',
                    custom: 'no',
                },
                {
                    name: 'Lighting',
                    budgetAmount: '',
                    custom: 'no',
                },
                {
                    name: 'Appliances',
                    budgetAmount: '',
                    custom: 'no',
                },
                {
                    name: 'Flooring',
                    budgetAmount: '',
                    custom: 'no',
                },
                {
                    name: 'Plumbing Fixtures',
                    budgetAmount: '',
                    custom: 'no',
                },
                {
                    name: 'Fireplace',
                    budgetAmount: '',
                    custom: 'no',
                },
            ],
        },
        {
            name: 'Final Steps',
            additionalItems: [
                {
                    name: 'Landscaping',
                    budgetAmount: '',
                    custom: 'no',
                },
                {
                    name: 'Outdoor Structures (deck, patio, porches)',
                    budgetAmount: '',
                    custom: 'no',
                },
                {
                    name: 'Driveway & Walks',
                    budgetAmount: '',
                    custom: 'no',
                },
                {
                    name: 'Clean Up',
                    budgetAmount: '',
                    custom: 'no',
                },
            ],
        },
    ],
};
